<template>
  <div class="m-item text-xs-center subheading">
    <div v-if="enabled" style="min-height: 160px;">
      <router-link :to="{path: route}" class="icon_link">
        <img class="icon" :src="icon" width="92" height="92" :class="featured ? 'blue_border' : ''" :alt="name">
      </router-link>
      <p class="font-weight-medium navy--text">{{name}}</p>
    </div>
    <div v-if="!enabled" style="min-height: 160px" class="restricted-icon">
      <img :src="icon" width="92" height="92" :alt="name">
      <p>{{name}}</p>
    </div>
  </div>
  
</template>

<script>
import {find} from 'lodash'
import manips from '@/data/manips.js'
const manipsURI = 'manipulatives/'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    enabled: {
      type: Boolean,
      default: true
    },
    featured: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      route: '',
      icon: '',
      name: ''
    }
  },
  mounted: function () {
    this.config = find(manips, {'id': this.id});

    this.route = manipsURI + this.config.id;
    this.icon = this.config.iconFileName;
    this.name = this.config.displayName;
  }
}
</script>

<style scoped>
.icon {
  cursor: pointer;
  border-radius: 18px;
  border: #b3d4fc solid 2px;
  background: white;
}
.icon_link :hover {
  border: #3296F3 solid 2px;
}

.blue_border {
  border: #3296F3 solid 2px;
}

p {
  font-size: 16px;
  padding: 0 24px;
}
a {
  color: #56544d;
}

.restricted-icon {
	filter: grayscale(100%) opacity(50%);
	-webkit-filter: grayscale(100%) opacity(50%);
}
</style>
